import { PropsWithChildren, useMemo } from 'react';

import { PreparedWorkload } from 'features/workload-optimization';

import { apiToFormModel, formModelToApi } from './_utils';
import { validateRightsizingSettingsV1 } from './_validations/rightsizing-settings-v1-validation.schema';
import { RightsizingSettingsFormBase } from './RightsizingSettingsFormBase';

/**
 * Form component for workload rightsizing settings (V1 - basic HPA).
 * Use when showHpaV2 feature flag is false.
 * Supports vertical scaling and basic horizontal scaling (min/max replicas only).
 */
export const RightsizingSettingsForm = ({
  workload,
  children,
}: PropsWithChildren<{
  workload: PreparedWorkload;
}>) => {
  const initialValue = useMemo(() => apiToFormModel(workload), [workload]);

  return (
    <RightsizingSettingsFormBase
      workload={workload}
      initialValue={initialValue}
      validate={validateRightsizingSettingsV1}
      formModelToApiFn={formModelToApi}
    >
      {children}
    </RightsizingSettingsFormBase>
  );
};
